import React from "react"
import { OverlayTrigger, Popover } from "react-bootstrap"

export default function InfoPopover({ desc, placement = "bottom", icon = "fa-info-circle" }) {
  return (
    <OverlayTrigger
      trigger={"click"}
      placement={placement}
      rootClose
      overlay={
        <Popover
          style={{
            backgroundColor: "black",
            padding: "2px 10px",
            borderRadius: 3,
            maxWidth: "400px",
            maxHeight: "400px",
            overflowY: "auto",
          }}
        >
          <Popover.Body>
            <span className="white-text-parent text_white">{desc}</span>
          </Popover.Body>
        </Popover>
      }
    >
      <span className={`fa ${icon}`} aria-hidden={"true"} style={{ cursor: "pointer" }} />
    </OverlayTrigger>
  )
}
